export default "__VITE_ASSET__HP5EAZC8__"